var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_14113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1434 11.2179H18.1848V29.5697H41.1434V11.2179Z",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.10352e-05 0.170761H6.98159L12.9496 28.4698",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9556 29.6053H14.0052C12.6454 29.6053 11.543 30.7077 11.543 32.0675C11.543 33.4274 12.6454 34.5297 14.0052 34.5297H44.9556C46.3155 34.5297 47.4178 33.4274 47.4178 32.0675C47.4178 30.7077 46.3155 29.6053 44.9556 29.6053Z",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9282 28.5782H12.9778C11.618 28.5782 10.5156 29.6806 10.5156 31.0404C10.5156 32.4003 11.618 33.5026 12.9778 33.5026H43.9282C45.2881 33.5026 46.3904 32.4003 46.3904 31.0404C46.3904 29.6806 45.2881 28.5782 43.9282 28.5782Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.137 14.4907H26.2915C25.325 14.4907 24.5416 15.2742 24.5416 16.2406V16.2697C24.5416 17.2362 25.325 18.0196 26.2915 18.0196H33.137C34.1034 18.0196 34.8869 17.2362 34.8869 16.2697V16.2406C34.8869 15.2742 34.1034 14.4907 33.137 14.4907Z",
    fill: "#BEC6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1096 13.4636H25.2641C24.2976 13.4636 23.5142 14.2471 23.5142 15.2135V15.2426C23.5142 16.2091 24.2976 16.9926 25.2641 16.9926H32.1096C33.076 16.9926 33.8595 16.2091 33.8595 15.2426V15.2135C33.8595 14.2471 33.076 13.4636 32.1096 13.4636Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.612 40.6129C21.0635 40.6129 22.2403 39.4361 22.2403 37.9846C22.2403 36.533 21.0635 35.3563 19.612 35.3563C18.1604 35.3563 16.9837 36.533 16.9837 37.9846C16.9837 39.4361 18.1604 40.6129 19.612 40.6129Z",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7291 40.6129C41.1806 40.6129 42.3573 39.4361 42.3573 37.9846C42.3573 36.533 41.1806 35.3563 39.7291 35.3563C38.2775 35.3563 37.1008 36.533 37.1008 37.9846C37.1008 39.4361 38.2775 40.6129 39.7291 40.6129Z",
    fill: "#E8EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5846 39.5858C20.0361 39.5858 21.2129 38.4091 21.2129 36.9575C21.2129 35.5059 20.0361 34.3292 18.5846 34.3292C17.133 34.3292 15.9563 35.5059 15.9563 36.9575C15.9563 38.4091 17.133 39.5858 18.5846 39.5858Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7016 39.5858C40.1532 39.5858 41.3299 38.4091 41.3299 36.9575C41.3299 35.5059 40.1532 34.3292 38.7016 34.3292C37.2501 34.3292 36.0734 35.5059 36.0734 36.9575C36.0734 38.4091 37.2501 39.5858 38.7016 39.5858Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.116 10.19H17.1575V28.5417H40.116V10.19Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5808 5.81428H16.7474V11.2181H42.5808V5.81428Z",
    fill: "#BEC6CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5535 4.78636H15.7201V10.1902H41.5535V4.78636Z",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3475 22.5957H37.6581",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3475 25.2838H37.6581",
    stroke: "#183243",
    strokeWidth: 0.342448,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_14113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4179,
    height: 40.6134,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.fab89f305c24d68546e97fe7fbdbe25f.svg";
export { ForwardRef as ReactComponent };